module.exports = __webpack_public_path__ + "static/media/group-phone.4d01fb4d.svg";